var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspot = function SvgHotspot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 14,
    height: 14,
    fill: "#F15D4F"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.6c.8 0 1.4.6 1.4 1.4S7.8 8.4 7 8.4 5.6 7.8 5.6 7 6.2 5.6 7 5.6",
    className: "hotspot_svg__st0"
  })));
};
export default SvgHotspot;